<template>
	<v-container class="container">
		<div class="ma-4 text-center" v-if="true">
			Due to unavoidable circumstances we are disabling all offline
			transactions with immediate effect
		</div>
		<div v-else>
			<v-flex xs12 class="mb-4">
				<v-select
					:items="appTypes"
					item-text="value"
					item-value="key"
					label="App"
					placeholder="Select App"
					class="body-1 text-field-wrapper pt-4"
					v-model="selectedAppType"
					:value="selectedAppType"
				></v-select>
			</v-flex>
			<div v-if="qrCodeOneLink" id="qrContainer">
				<qr-code
					:appType="selectedAppType"
					:link="qrCodeOneLink"
					:phoneNo="phoneNo"
				/>
			</div>
			<div v-if="isOnlineUser">
				<div>Link: {{ qrCodeOneLink }}</div>
				<div
					:style="{
						background: appSpecficData[selectedAppType].primaryColor
					}"
					@click="copyToClipBoard()"
					class="actionBtn white--text text-center"
				>
					Copy Link
				</div>
			</div>
			<v-btn
				v-if="isJeet11TSM"
				@click="openQrModal"
				:style="{
					background: appSpecficData[selectedAppType].primaryColor
				}"
				class="white--text"
				>Generate QR for Associates</v-btn
			>
			<div class="actionButtons">
				<div @click="downloadImage('qrContainer')" class="actionBtn">
					Download QR Code
				</div>
				<div
					@click="shareImage('qrContainer')"
					class="actionBtn white--text"
					:style="{
						background: appSpecficData[selectedAppType].primaryColor
					}"
				>
					Share QR Code
				</div>
			</div>
			<div v-if="isDataLoading" class="overlay">
				<v-progress-circular
					:indeterminate="true"
				></v-progress-circular>
			</div>
			<v-dialog
				width="600px"
				persistent
				v-model="qrModal"
				fullscreen
				hide-overlay
			>
				<v-card>
					<v-card-text class="pa-4">
						<v-layout class="justify-space-between mb-2">
							<h5 class="title indigo-text text--darken-4">
								Generate QR Code for Associates
							</h5>
							<v-btn
								fab
								flat
								class="top-right-align"
								@click="closeModal()"
							>
								<v-icon>close</v-icon>
							</v-btn>
						</v-layout>
						<v-layout row wrap class="mb-4">
							<v-flex xs12 md6 lg3>
								<v-text-field
									v-model="associateNumber"
									label="Associate Phone Number*"
									type="number"
									placeholder="Associate Phone Number"
									class="text-field-wrapper ma-0 pt-4"
								/>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs12 md6 lg3 class="d-flex mt-4">
								<v-btn
									class="white--text ma-0 py-4 btn"
									:loading="searchingAssociate"
									:color="themeInputColor"
									@click="searchAssociate"
									:disabled="associateNumber.length !== 10"
									>Search Associate</v-btn
								>
							</v-flex>
						</v-layout>
					</v-card-text>
					<div
						v-if="associateQrCodeOneLink"
						id="associateQrContainer"
					>
						<qr-code
							:link="associateQrCodeOneLink"
							:phoneNo="associateNumber"
							:appType="selectedAppType"
						/>
						<div class="actionButtons noFixed">
							<div
								@click="downloadImage('associateQrContainer')"
								class="actionBtn"
							>
								Download QR Code
							</div>
							<div
								@click="shareImage('associateQrContainer')"
								class="actionBtn white--text"
								:style="{
									background:
										appSpecficData[selectedAppType]
											.primaryColor
								}"
							>
								Share QR Code
							</div>
						</div>
					</div>
				</v-card>
			</v-dialog>
		</div>
	</v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as htmlToImage from "html-to-image";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import EventsManager from "@/event-manager";
import { SHOW_ALERT, GET_RETAILER_BY_PHONE } from "@/store/action-types";
import { promptToDownloadFile } from "../../utils";
import QRCode from "./QRCode.vue";

export default {
	name: "QRCode",
	components: {
		"qr-code": QRCode
	},
	data: () => ({
		appTypes: [
			{ key: "JEET11", value: "Jeet11 Fantasy" },
			{ key: "RUMMY", value: "Jeet11 Rummy" }
		],
		isDataLoading: false,
		qrCodeOneLink: "",
		qrModal: false,
		associateNumber: "",
		searchingAssociate: false,
		associateQrCodeOneLink: "",
		selectedAppType: "JEET11",
		appSpecficData: {
			JEET11: {
				primaryColor: "#1890ff",
				shareTitle: "Download Jeet11 App",
				shareText: "Download Jeet11 App Now and Win 5 Crores"
			},
			RUMMY: {
				primaryColor: "#6d1818",
				shareTitle: "Download Jeet11 Rummy App",
				shareText: "Download Jeet11 Rummy App Now and Win 5 Crores"
			}
		}
	}),
	mounted() {
		if (this.phoneNo) {
			this.fetchOneLink();
		}
	},
	methods: {
		async fetchOneLink(phoneNo = null) {
			if (this.isDataLoading) {
				return;
			}
			this.isDataLoading = true;
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					appName: this.selectedAppType,
					phoneNo: phoneNo || Number(String(this.phoneNo).slice(2))
				}
			};
			const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getUserOneLink`;
			const response = await ApiService.post(endpoint, payload);
			const { response: data, statusCode } = response;
			if (statusCode === 200) {
				const { oneLink } = data;
				if (phoneNo) {
					this.associateQrCodeOneLink = oneLink;
				} else {
					this.qrCodeOneLink = oneLink;
				}
			} else {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Could not generate QR Code"
				});
			}
			this.isDataLoading = false;
		},
		sendEvent() {
			EventsManager.sendEvent({
				name: "QR_CODE_TAB_OPENED",
				properties: {
					userId: this.userId,
					type: this.storeType
				}
			});
		},
		async generateImageBlob(id) {
			const el = document.getElementById(id);
			const scale = 2;
			const height = el.scrollHeight;
			const width = el.scrollWidth;
			const blob = await htmlToImage.toBlob(el, {
				width: width,
				height: height,
				canvasWidth: width * scale,
				canvasHeight: height * scale,
				cacheBust: true,
				quality: 1,
				pixelRatio: 2,
				skipAutoScale: true
			});
			return blob;
		},
		async shareImage(id) {
			const blob = await this.generateImageBlob(id);
			const fileName = `qrCode-${
				id === "qrContainer" ? this.phoneNo : this.associateNumber
			}-${this.selectedAppType}`;
			const file = new File([blob], fileName, {
				type: blob.type
			});
			const title = this.appSpecficData[this.selectedAppType].shareTitle;
			const text = this.appSpecficData[this.selectedAppType].shareText;
			if (window.ReactNativeWebView) {
				const reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onloadend = () => {
					const url = reader.result;
					const payload = {
						url,
						title,
						text
					};
					window.ReactNativeWebView.postMessage(
						JSON.stringify(payload)
					);
				};
			} else if (
				!window.ReactNativeWebView &&
				navigator.canShare({ files: [file] })
			) {
				try {
					await navigator.share({
						files: [file],
						title,
						text
					});
				} catch (err) {
					this.$store.dispatch(SHOW_ALERT.dispatch, {
						text:
							"Image cannot be shared from Desktop. Downloading..."
					});
					this.downloadImage(id);
				}
			} else {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Image cannot be shared from Desktop. Downloading..."
				});
				this.downloadImage(id);
			}
		},
		async downloadImage(id) {
			const blob = await this.generateImageBlob(id);
			const fileUrl = URL.createObjectURL(blob);
			const fileName = `qrCode-${
				id === "qrContainer" ? this.phoneNo : this.associateNumber
			}-${this.selectedAppType}`;
			promptToDownloadFile(fileUrl, fileName);
		},
		openQrModal() {
			this.qrModal = true;
		},
		closeModal() {
			this.associateNumber = "";
			this.associateQrCodeOneLink = "";
			this.qrModal = false;
		},
		searchAssociate() {
			if (this.searchingAssociate) {
				return;
			}
			this.searchingAssociate = true;
			this.$store
				.dispatch(GET_RETAILER_BY_PHONE.dispatch, {
					retailerPhone: "91" + this.associateNumber,
					projections: ["userType"]
				})
				.then(data => {
					const { status, retailerData = {} } = data;
					if (
						status === "success" &&
						Object.keys(retailerData).length > 0
					) {
						this.fetchOneLink(this.associateNumber);
					} else {
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text:
								"Phone number not registered, please check the phone number"
						});
					}
				})
				.finally(() => {
					this.searchingAssociate = false;
				});
		},
		copyToClipBoard() {
			const text = this.qrCodeOneLink;
			try {
				let input = document.createElement("input");
				input.setAttribute("value", text);
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Copied successfully!"
				});
			} catch (e) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Error occured while copying"
				});
			}
		}
	},
	computed: {
		...mapGetters({
			isJeet11TSM: "auth/isJeet11TSM",
			isOnlineUser: "auth/isOnlineUser"
		}),
		...mapState({
			userId: state => state.auth.USERID,
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			storeType: state => state.jeet11.jeet11PartnerDetails.userType,
			phoneNo: state => state.jeet11.jeet11PartnerDetails.phoneNo
		}),
		themeInputColor() {
			return this.appSpecficData[this.selectedAppType].primaryColor;
		}
	},
	watch: {
		selectedAppType(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.fetchOneLink();
			}
		},
		phoneNo(newVal) {
			if (newVal) {
				this.fetchOneLink();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.container {
	margin-bottom: 80px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.actionButtons {
	position: fixed;
	bottom: 0;
	width: 100%;
	margin-left: -16px;
	max-width: 600px;
	background: #ccc;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-around;
}
.noFixed {
	max-width: unset;
	margin-left: 0;
	position: unset;
}
.actionBtn {
	background: white;
	border: 1px solid #d9d9d9;
	padding: 5px 16px;
	border-radius: 2px;
	box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.02);
}
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}
</style>
